<template>
  <v-container fill-height fluid grid-list-lg class="pa-3">
    <v-layout row wrap>
      <v-flex xs12 md3 :style="{height:blockHeight, 'overflow-y':'auto'}">
        <v-card>
          <v-system-bar window dark color="accent" style="width: 100%">
            <v-icon center>mdi-format-list-bulleted-type</v-icon>
            <v-toolbar-title class="ml-1 pointer" @click="expanded.my=!expanded.my">Мои мониторы <v-icon>{{expanded.my?'mdi-chevron-up':'mdi-chevron-down'}}</v-icon></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip top>
              <v-btn icon slot="activator" @click="openMonitorForm(null)" class="mx-0"><v-icon class="mx-0">mdi-plus</v-icon></v-btn>
              <span>Добавить монитор</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn icon slot="activator" @click="openFolderForm(null)" class="mx-0"><v-icon class="mx-0">mdi-folder-plus</v-icon></v-btn>
              <span>Добавить папку</span>
            </v-tooltip>
          </v-system-bar>
          <v-card-text class="objects-list px-0 py-2" v-show="expanded.my">
            <v-treeview :items="my_monitors" class="densed pb-1 ovflowxscroll" item-key="key">
              <template slot="prepend" slot-scope="{ item, open, leaf }">
                <v-icon size="20" class="mx-0" @contextmenu="openMenu($event, item, 'my')">{{item.icon}}</v-icon>
              </template>
              <label slot="label" class="pointer" slot-scope="{item}" @click="getMonitorGraphs(item)" @contextmenu="openMenu($event, item, 'my')">{{item.name}}</label>
            </v-treeview>
          </v-card-text>
        </v-card>
        
        <v-card class="mt-3">
          <v-system-bar window dark color="accent" style="width: 100%">
            <v-icon center>mdi-share-variant</v-icon>
            <v-toolbar-title class="ml-1 pointer" @click="expanded.shared=!expanded.shared">Доступные мне <v-icon>{{expanded.shared?'mdi-chevron-up':'mdi-chevron-down'}}</v-icon></v-toolbar-title>
          </v-system-bar>
          <v-card-text class="objects-list px-0 py-2" v-show="expanded.shared">
            <v-treeview :items="shared_monitors" class="densed pb-1 ovflowxscroll" item-key="key">
              <template slot="prepend" slot-scope="{ item, open, leaf }">
                <v-icon size="20" class="mx-0" @contextmenu="openMenu($event, item, 'shared')">{{item.icon}}</v-icon>
              </template>
              <label slot="label" class="pointer" slot-scope="{item}" @click="getMonitorGraphs(item)" @contextmenu="openMenu($event, item, 'shared')">{{item.name}}</label>
            </v-treeview>
          </v-card-text>
        </v-card>
        
        <v-card class="mt-3">
          <v-system-bar window dark color="accent" style="width: 100%">
            <v-icon center>mdi-delete</v-icon>
            <v-toolbar-title class="ml-1 pointer" @click="expanded.trash=!expanded.trash">Корзина <v-icon>{{expanded.trash?'mdi-chevron-up':'mdi-chevron-down'}}</v-icon></v-toolbar-title>
          </v-system-bar>
          <v-card-text class="objects-list px-0 py-2" v-show="expanded.trash">
            <v-treeview :items="trash_monitors" class="densed pb-1 ovflowxscroll" item-key="key">
              <template slot="prepend" slot-scope="{ item, open, leaf }">
                <v-icon size="20" class="mx-0" @contextmenu="openMenu($event, item, 'trash')">{{item.icon}}</v-icon>
              </template>
              <label slot="label" class="pointer" slot-scope="{item}" @contextmenu="openMenu($event, item, 'trash')">{{item.name}}</label>
            </v-treeview>
          </v-card-text>
        </v-card>
      </v-flex>
      
      <v-flex xs12 md9 :style="{height:blockHeight, 'overflow-y':'auto'}" v-if="selectedMonitor">
        <v-card>
          <v-system-bar window dark color="accent" style="width: 100%">
            <v-icon center>mdi-monitor</v-icon>
            <v-toolbar-title class="ml-1">Монитор</v-toolbar-title>
            <v-spacer></v-spacer>
            <div>
              <span v-if="periodFrom || periodTo" class="subheading">
                <span v-if="periodFrom">{{formatDate(periodFrom).dots}}</span><v-icon v-else class="mx-1">mdi-infinity</v-icon> -
                <span v-if="periodTo">{{formatDate(periodTo).dots}}</span><v-icon v-else class="mx-1">mdi-infinity</v-icon>
              </span>
              <v-btn small icon @click="openPeriodForm"><v-icon center class="mx-0">mdi-calendar</v-icon></v-btn>
            </div>
          </v-system-bar>
          
          <v-card-text class="pa-0">
            <div class="my-2" style="display: flex">
              <h1 class="headline mx-2 text-xs-center" style="flex:30">{{selectedMonitor.name}}</h1>
              <div style="flex:1 30px" class="text-xs-right">
                <v-tooltip top>
                  <v-btn slot="activator" icon color="info" @click="createStatistic"><v-icon>mdi-plus</v-icon></v-btn>
                  <span>Создать статистику и добавить ее в монитор</span>
                </v-tooltip>
              </div>
            </div>
            
            <template v-if="loaded">
              <v-flex xs12 v-if="statistics.length===0" class="text-xs-center mt-5">
                <p class="headline">В данном наборе отсутствуют статистики</p>
              </v-flex>
              <v-layout row wrap v-else>
                <v-flex xs12 lg6 class="text-xs-center" v-for="(statistic, index) in statistics" :key="index">
                  <d-statistic :statistic="statistic" :id="statistic.id" ref="chart" with_delete with_periods @delete-stat="deleteFromSet"></d-statistic>
                </v-flex>
                <v-flex xs12 lg6 class="text-xs-center py-5" v-if="loading">
                  <p>Загрузка ...</p>
                  <v-progress-circular :size="70" :width="7" indeterminate color="primary"></v-progress-circular>
                </v-flex>
              </v-layout>
            </template>
            <v-flex xs12 class="text-xs-center py-5" v-else>
              <p>Загрузка ...</p>
              <v-progress-circular :size="70" :width="7" indeterminate color="primary"></v-progress-circular>
            </v-flex>
          </v-card-text>
        
        </v-card>
      </v-flex>
    </v-layout>
    
    <v-menu v-model="menu.show" :position-x="menu.x" :position-y="menu.y" absolute offset-y>
      <v-list id="analytics-objects-menu">
        <v-list-tile v-if="currentObject && currentObject.element_type ==='monitor'" @click="infoItem">
          <v-list-tile-action><i class="mdi mdi-information"></i></v-list-tile-action>
          <v-list-tile-title>Информация</v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-if="currentObject && currentObject.element_type ==='monitor' && currentTree!=='trash'" @click="editStatistic">
          <v-list-tile-action><i class="mdi mdi-chart-line"></i></v-list-tile-action>
          <v-list-tile-title>Статистики монитора</v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-if="currentTree==='my'" @click="editItem">
          <v-list-tile-action><i class="mdi mdi-pencil"></i></v-list-tile-action>
          <v-list-tile-title>Редактировать</v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-if="currentTree==='my' && currentObject.element_type ==='folder'" @click="openFolderForm(null, currentObject.id)">
          <v-list-tile-action><i class="mdi mdi-folder-plus"></i></v-list-tile-action>
          <v-list-tile-title>Добавить папку</v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-if="currentTree==='my' && currentObject.element_type ==='folder'" @click="openMonitorForm(null, currentObject.id)">
          <v-list-tile-action><i class="mdi mdi-plus"></i></v-list-tile-action>
          <v-list-tile-title>Добавить монитор</v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-if="currentTree!=='shared'" @click="deleteItem">
          <v-list-tile-action><i class="mdi mdi-delete"></i></v-list-tile-action>
          <v-list-tile-title>Удалить</v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-if="currentTree==='trash'" @click="restoreItem">
          <v-list-tile-action><i class="mdi mdi-restore"></i></v-list-tile-action>
          <v-list-tile-title>Восстановить</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
    
    <v-dialog v-model="dialog" :max-width="dialogWidth" scrollable persistent>
      <component :is="currentComponent" v-if="dialog" v-bind="formProps" @close-dialog="dialog=false" @save="saveChanges"></component>
    </v-dialog>
  </v-container>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import entities from '@/mixins/entities'
  import DStatistic from '../Common/Statistic'
  import MonitorForm from './Forms/MonitorForm'
  import FolderForm from './Forms/FolderForm'
  import InfoForm from './Forms/InfoForm'
  import PeriodForm from './Forms/PeriodForm'
  import StatisticForm from './Forms/StatisticForm'
  import MonitorStatisticsForm from './Forms/MonitorStatisticsForm'
  
  export default {
    name : "Sets",
  
    mixins: [entities],
  
    components:{
      DStatistic,
    },
  
    created() {
      this.getTree()
    },
    
    computed:{
      blockHeight(){
        return (this.$vuetify.breakpoint.height - 48 - 40 - 30 )+'px'
      },
      ...mapGetters('app/helpers',['formatDate']),
      ...mapState(`analytics/statistics`, ['my_monitors', 'shared_monitors', 'trash_monitors']),
    },
  
    data(){
      return {
        menu:{
          x: 0,
          y: 0,
          show: false
        },
        currentTree: null,
        currentObject: null,
        currentComponent: null,
        dialog: false,
        formProps: {},
        dialogWidth: 600,
        selectedMonitor: null,
        loading: false,
        loaded: false,
        statistics: [],
        periodFrom: null,
        periodTo: null,
        expanded: {
          my: true,
          shared: true,
          trash: false
        },
      }
    },
  
    methods: {
      getTree() {
        this.$store.dispatch('analytics/statistics/getMonitors')
        this.$store.dispatch('analytics/statistics/getGraphs')
        this.$store.dispatch('analytics/statistics/getProperties')
      },
  
      getMonitorGraphs(item){
        this.statistics = []
        if(item.element_type==='monitor'){
          this.selectedMonitor = item
          this.loading = true
          this.loaded = false
          this.$store.dispatch( 'analytics/statistics/getMonitorGraphs', item.id ).then( graphs => {
            this.loadGraph(graphs)
          })
        } else {
          this.selectedMonitor = null
        }
      },
      
      loadGraph(graphs){
        if(graphs.length>0){
          this.loading = true
          let graph = graphs.shift()
          let lines = []
          graph.lines.map(line => lines.push(line.id))
          let postdata = {id: graph.graph_id, period: 0, type: 'graph', mode: 'graph', data: {lines, from: this.periodFrom, to: this.periodTo, interface: 'monitor'}}
          
          this.$store.dispatch('analytics/statistics/getGraphData', postdata).then( response => {
            this.loaded = true
            response.unit = ''
            this.convertOutputSettings(response.lines)
            this.statistics.push(response)
          }).catch( error => {
            let message = 'Возникла ошибка при попытке загрузить график "'+graph.name+'"'
            if(error.response && error.response.data.message){
              message = error.response.data.message
            }
            this.$dmsErrorNoty(message)
          }).finally( () => {
            this.loadGraph(graphs)
          })
        } else {
          this.loading = false
          this.loaded = true
        }
      },
      
      openMonitorForm(data = null, parent_id = null){
        this.currentComponent = MonitorForm
        this.formProps = {
          parent_id
        }
        if(data!=null){
          this.formProps = {
            editMode: true,
            data,
            parent_id
          }
        }
        this.dialogWidth = 1000
        this.dialog = true
      },
  
      openFolderForm(data = null, parent_id = null){
        this.currentComponent = FolderForm
        this.formProps = {
          type: 'monitor',
          parent_id
        }
        if(data!=null){
          this.formProps = {
            editMode: true,
            data,
            type: 'monitor',
            parent_id
          }
        }
        this.dialogWidth = 600
        this.dialog = true
      },
  
      openMenu( e, item, tree ) {
        e.preventDefault()
        this.currentObject = item
        this.currentTree = tree
        this.menu.show = false
        this.menu.x = e.clientX
        this.menu.y = e.clientY
        this.$nextTick( () => {
          this.menu.show = true
        })
      },
  
      editItem(){
        if(this.currentObject.element_type === 'folder'){
          this.openFolderForm(this.currentObject, this.currentObject.parent_id)
        } else if(this.currentObject.element_type === 'monitor'){
          this.openMonitorForm(this.currentObject, this.currentObject.parent_id)
        }
      },
  
      deleteItem(){
        let trash = (this.currentTree === 'trash')
        if(this.currentObject.element_type === 'folder'){
          this.$dmsAgree('Вы уверены, что хотите удалить папку и все вложенные элементы?').then( _ => {
            this.$store.dispatch('analytics/statistics/deleteFolder', {id: this.currentObject.id, type: 'monitor', trash}).catch( error => {
              let message = 'Возникла ошибка при удалении папки'
              if(error.response && error.response.data.message){
                message = error.response.data.message
              }
              this.$dmsErrorNoty(message)
            })
          })
        } else if(this.currentObject.element_type === 'monitor'){
          this.$dmsAgree('Вы уверены, что хотите удалить монитор?').then( _ => {
            this.$store.dispatch('analytics/statistics/deleteMonitor', {id: this.currentObject.id, trash}).catch( error => {
              let message = 'Возникла ошибка при удалении монитора'
              if(error.response && error.response.data.message){
                message = error.response.data.message
              }
              this.$dmsErrorNoty(message)
            })
          })
        }
      },
  
      restoreItem(){
        if(this.currentObject.element_type === 'folder'){
          this.$store.dispatch('analytics/statistics/restoreFolder', {id: this.currentObject.id, type: 'monitor'}).catch( error => {
            let message = 'Возникла ошибка при восстановлении папки'
            if(error.response && error.response.data.message){
              message = error.response.data.message
            }
            this.$dmsErrorNoty(message)
          })
        } else if(this.currentObject.element_type === 'monitor'){
          this.$store.dispatch('analytics/statistics/restoreMonitor', this.currentObject.id).catch( error => {
            let message = 'Возникла ошибка при восстановлении мониора'
            if(error.response && error.response.data.message){
              message = error.response.data.message
            }
            this.$dmsErrorNoty(message)
          })
        }
      },
  
      infoItem(){
        this.currentComponent = InfoForm
        this.formProps = {
          id: this.currentObject.id,
          type: 'monitor'
        }
        this.dialogWidth = 600
        this.dialog = true
      },
  
      editStatistic(){
        this.currentComponent = MonitorStatisticsForm
        this.formProps = {
          id: this.currentObject.id
        }
        this.dialogWidth = 1000
        this.dialog = true
      },
  
      deleteFromSet(id){
        const index = this.statistics.findIndex( el => el.id === id)
        if(index>-1){
          this.loaded = false
          this.$store.dispatch('analytics/statistics/removeGraph', {
            graph_id: id,
            monitor_id: this.selectedMonitor.id,
          }).then( response => {
            this.statistics.splice(index,1)
          }).finally( _ => {
            this.loaded = true
          })
        }
      },
  
      createStatistic(){
        this.currentComponent = StatisticForm
        this.formProps = {}
        this.dialogWidth = 1000
        this.dialog = true
      },
  
      openPeriodForm(){
        this.currentComponent = PeriodForm
        this.formProps = {}
        this.dialogWidth = 650
        this.dialog = true
      },
  
      saveChanges(eventData){
        switch(eventData.type){
          case 'graph':
            let data = {
              graph_id: eventData.data.id,
              all: true,
              lines: []
            }
            this.$store.dispatch('analytics/statistics/addMonitorGraph', {id: this.selectedMonitor.id, data}).then(response => {
              let lines = []
              response.lines.map(line => lines.push(line.id))
              let postdata = {id: eventData.data.id, period: 0, type: 'graph', mode: 'graph', data: {lines}}
              this.$store.dispatch('analytics/statistics/getGraphData', postdata).then( response => {
                this.loaded = true
                response.unit = ''
                this.convertOutputSettings(response.lines)
                this.statistics.push(response)
              }).catch( error => {
                let message = 'Возникла ошибка при попытке загрузить график "'+eventData.data.name+'"'
                if(error.response && error.response.data.message){
                  message = error.response.data.message
                }
                this.$dmsErrorNoty(message)
              })
            })
            break
          case 'period':
            this.periodFrom = eventData.data.periodFrom
            this.periodTo = eventData.data.periodTo
            this.getMonitorGraphs(this.selectedMonitor)
            break
          case 'monitorstatistics':
            if(this.selectedMonitor.id===eventData.data.id){
              this.getMonitorGraphs(this.selectedMonitor)
            }
            break
        }
        this.dialog = false
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/analytics/components/Statistics/Sets.vue